import axios from '@/helpers/axios';
import { approvalFlowApi } from '@/helpers/apis';

export const getTransferLineOrder = (link: string) => {
  const url = approvalFlowApi.GET_TRANSFER_LINE_ORDER;
  return axios.post(url, { encLink: link });
};

export const getTransferLineDocById = (requestId) => {
  const url = `${approvalFlowApi.GET_TRANSFER_LINE_DOC_BY_ID}`;
  return axios.post(url, { requestId: requestId });
};

export const getUnmaskingApproval = (link: string) => {
  const url = `${approvalFlowApi.GET_UNMASKING_APPROVAL}`;
  return axios.post(url, { encLink: link });
};

export const updateUnmaskingApprovalStatus = (payload) => {
  const url = `${approvalFlowApi.UPDATE_UNMASKING_STATUS}`;
  return axios.post(url, { ...payload });
};
